'use es6';

import { getDisplayParamsColorTheme } from 'reporting-data/report/configReportGetters';
import ColorThemeEditor from 'report-customization-components/components/color-theme-dropdown/ColorThemeDropdown';
import { getIsReportValidForCustomizationComponentId } from 'report-customization-components/lib/reportCustomizationComponentFetchers';
import { REPORT_CUSTOMIZATION_COMPONENT_IDS } from 'report-customization-components/constants/report-customization-components/componentTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const ColorThemeControl = ({
  report,
  updateContext
}) => /*#__PURE__*/_jsx(ColorThemeEditor, {
  report: report,
  onChange: updatedReport => {
    updateContext({
      colorTheme: getDisplayParamsColorTheme(updatedReport)
    }, report);
  }
});
ColorThemeControl.isUsableForReport = ({
  report
}) => getIsReportValidForCustomizationComponentId(REPORT_CUSTOMIZATION_COMPONENT_IDS.COLOR_THEME_DROPDOWN, report);
export default ColorThemeControl;